export default __webpack_public_path__ + "static/media/security.afb12dc8.png";